// Configuration for the buyer's Courtesy of / Getty requests (order requests, 3 Nov 2026).
//
// Adapter selection. THREE modes, committed default 'off', compared with === against the exact strings, the same
// discipline as every other _MODE flag (CLAUDE.md, the strict-equality flags). A wrong-cased or padded value is
// present, non-empty, and still off.
//
// 'off'  -> no notice on the video page, no Request approval, no My requests row or page: the site is exactly today's.
//           UAT and prod are off (no variable there compiles to undefined, which is off).
// 'mock' -> local work only: a stand-in for the gateway. NEVER IN A PRODUCTION BUILD: NODE_ENV comes from the build
//           command (react-scripts: production for `npm run build`), and no environment variable can change it, so a
//           deployed build maps 'mock' to 'off' whatever a variable says (the adminVideos rule, Igor's review of #82).
// 'live' -> the gateway's /api/v1/customer/order-requests routes. Dev sets it in dev-cicd.yaml (Joey, 3 Nov, Q-J10).
//
// It goes on together with the server's rights check (config/order_requests.rightsCheck): with the check on and this
// flag off, a buyer would meet a 428 with no way to ask (analysis 5.4, item 8).
const MOCK_ALLOWED = process.env.NODE_ENV !== 'production';

export const ORDER_REQUESTS_MODE: 'off' | 'mock' | 'live' =
  process.env.REACT_APP_ORDER_REQUESTS_MODE === 'live'
    ? 'live'
    : process.env.REACT_APP_ORDER_REQUESTS_MODE === 'mock' && MOCK_ALLOWED
      ? 'mock'
      : 'off';

export const ORDER_REQUESTS_ENABLED = ORDER_REQUESTS_MODE !== 'off';

// The gateway's buyer routes, under API_BASE_URL (/api/v1), beside the order routes they resemble.
export const ORDER_REQUESTS_ROUTE = '/customer/order-requests';
export const orderRequestRoute = (id: string): string => `${ORDER_REQUESTS_ROUTE}/${encodeURIComponent(id)}`;
export const ORDER_REQUESTS_SEEN_ROUTE = `${ORDER_REQUESTS_ROUTE}/seen`;

// What the buyer types, bounded as the server bounds it (contract 4.1). The server checks again.
export const REQUEST_FIELD_LIMITS = {
  companyMin: 2,
  companyMax: 120,
  projectMax: 120,
  messageMax: 1000,
} as const;

/** The most ids one /seen call may carry (the server's limit). */
export const SEEN_IDS_MAX = 100;

/** A request id, as the server makes them. Anything else is not sent anywhere. */
export const ORDER_REQUEST_ID_PATTERN = /^[A-Za-z0-9]{20}$/;

export const ORDER_REQUESTS_TIMEOUT_MS = 30_000;
